import React from 'react';

interface ButtonProps extends React.ButtonHTMLAttributes<HTMLButtonElement> {
  variant?: 'primary' | 'secondary';
  children: React.ReactNode;
  className?: string;
}

export function Button({
  variant = 'primary',
  children,
  className = '',
  ...props
}: ButtonProps) {
  const baseStyles =
    'inline-flex items-center justify-center rounded-lg font-semibold transition-all duration-200 focus:outline-none focus:ring-2 focus:ring-offset-2';
  const variants = {
    primary:
      'bg-red text-white hover:bg-red-dark shadow-sm hover:shadow-md transform hover:-translate-y-px focus:ring-red',
    secondary:
      'bg-transparent text-black border border-gray-200 hover:bg-gray-50 hover:border-gray-300 focus:ring-gray-500',
  };
  const sizes = 'px-6 py-3 text-sm';

  return (
    <button
      className={`${baseStyles} ${variants[variant]} ${sizes} ${className}`}
      {...props}
    >
      {children}
    </button>
  );
}
